import React from "react";
import PropTypes from "prop-types";
import { ToastContainer } from "react-toastify";
import { Breadcrumbs } from "@opendate-app/setlist";
import RegistrationDetailPage from "./RegistrationDetailPage";
import { RegistrationPageProvider, useRegistrationPageContext } from "./registrationPage/RegistrationPageContext";

function RegistrationBreadcrumbs({ items }) {
  const { registration } = useRegistrationPageContext();
  const crumbs = registration ? [...items, { label: registration.full_name }] : items;
  return <div className="mb-3 classes-wrapping-crumbs"><Breadcrumbs items={crumbs} /></div>;
}

RegistrationBreadcrumbs.propTypes = { items: PropTypes.array.isRequired };

function ClassRegistrationShowApp({ registration, paths, csrfToken, canManage, canResend, currencyCode, breadcrumb }) {
  return (
    <div className="od-themed p-4">
      <RegistrationPageProvider initialRegistration={registration} paths={paths} csrfToken={csrfToken} canManage={canManage} canResend={canResend} currencyCode={currencyCode}>
        <RegistrationBreadcrumbs items={breadcrumb} />
        <RegistrationDetailPage />
      </RegistrationPageProvider>
      <ToastContainer icon={false} />
    </div>
  );
}

ClassRegistrationShowApp.propTypes = {
  registration: PropTypes.object,
  paths: PropTypes.shape({
    registration: PropTypes.string.isRequired,
    classInstance: PropTypes.string.isRequired,
  }).isRequired,
  csrfToken: PropTypes.string.isRequired,
  canManage: PropTypes.bool,
  canResend: PropTypes.bool,
  currencyCode: PropTypes.string,
  breadcrumb: PropTypes.array.isRequired,
};

export default ClassRegistrationShowApp;
